/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectWorkingGroup} from "./searchObjects"



export function fillSearchObjectWorkingGroup(){
    searchObjectWorkingGroup.categories = [];
    searchObjectWorkingGroup.keywords = [];

    const checkbox = document.getElementById("categoryWorkingGroup");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectWorkingGroup.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonWorkingGroupAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectWorkingGroup.any = true;
    }

    const allButton = document.getElementById("buttonWorkingGroupAll");
    if(allButton.classList.contains("chosen")){
        searchObjectWorkingGroup.any = false;
    }
    
    const buttonB2G = document.getElementById("buttonWorkingGroupB2G");
    if(buttonB2G.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonB2G.value)
    }
    
    const buttonBPH = document.getElementById("buttonWorkingGroupBPH");
    if(buttonBPH.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonBPH.value)
    }
    
    const buttonBTV = document.getElementById("buttonWorkingGroupBTV");
    if(buttonBTV.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonBTV.value)
    }
    
    const buttonCFT = document.getElementById("buttonWorkingGroupCFT");
    if(buttonCFT.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonCFT.value)
    }
    
    const buttonDIF = document.getElementById("buttonWorkingGroupDIF");
    if(buttonDIF.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonDIF.value)
    }
    
    const buttonEGM = document.getElementById("buttonWorkingGroupEGM");
    if(buttonEGM.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonEGM.value)
    }
    
    const buttonEWK = document.getElementById("buttonWorkingGroupEWK");
    if(buttonEWK.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonEWK.value)
    }
    
    const buttonEXO = document.getElementById("buttonWorkingGroupEXO");
    if(buttonEXO.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonEXO.value)
    }
    
    const buttonFSQ = document.getElementById("buttonWorkingGroupFSQ");
    if(buttonFSQ.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonFSQ.value)
    }
    
    const buttonFTR = document.getElementById("buttonWorkingGroupFTR");
    if(buttonFTR.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonFTR.value)
    }
    
    const buttonFWD = document.getElementById("buttonWorkingGroupFWD");
    if(buttonFWD.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonFWD.value)
    }
    
    const buttonGEN = document.getElementById("buttonWorkingGroupGEN");
    if(buttonGEN.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonGEN.value)
    }
    
    const buttonHIG = document.getElementById("buttonWorkingGroupHIG");
    if(buttonHIG.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonHIG.value)
    }
    
    const buttonHIN = document.getElementById("buttonWorkingGroupHIN");
    if(buttonHIN.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonHIN.value)
    }
    
    const buttonJME = document.getElementById("buttonWorkingGroupJME");
    if(buttonJME.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonJME.value)
    }
    
    const buttonLUM = document.getElementById("buttonWorkingGroupLUM");
    if(buttonLUM.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonLUM.value)
    }
    
    const buttonMUO = document.getElementById("buttonWorkingGroupMUO");
    if(buttonMUO.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonMUO.value)
    }
    
    const buttonPFT = document.getElementById("buttonWorkingGroupPFT");
    if(buttonPFT.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonPFT.value)
    }
    
    const buttonPPS = document.getElementById("buttonWorkingGroupPPS");
    if(buttonPPS.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonPPS.value)
    }
    
    const buttonPRF = document.getElementById("buttonWorkingGroupPRF");
    if(buttonPRF.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonPRF.value)
    }
    
    const buttonQCD = document.getElementById("buttonWorkingGroupQCD");
    if(buttonQCD.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonQCD.value)
    }
    
    const buttonSBM = document.getElementById("buttonWorkingGroupSBM");
    if(buttonSBM.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonSBM.value)
    }
    
    const buttonSMP = document.getElementById("buttonWorkingGroupSMP");
    if(buttonSMP.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonSMP.value)
    }
    
    const buttonSUS = document.getElementById("buttonWorkingGroupSUS");
    if(buttonSUS.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonSUS.value)
    }
    
    const buttonTAU = document.getElementById("buttonWorkingGroupTAU");
    if(buttonTAU.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonTAU.value)
    }
    
    const buttonTOP = document.getElementById("buttonWorkingGroupTOP");
    if(buttonTOP.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonTOP.value)
    }
    
    const buttonTRG = document.getElementById("buttonWorkingGroupTRG");
    if(buttonTRG.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonTRG.value)
    }
    
    const buttonTRK = document.getElementById("buttonWorkingGroupTRK");
    if(buttonTRK.classList.contains('selected')){
        searchObjectWorkingGroup.keywords.push(buttonTRK.value)
    }
    
    getAllFiltered()

}